import { post } from '@/utils/examMan/request'

export function fetchSts() {
  return post('/api/common/oss/sts')
}
